export const routerPath: { [key: string]: string } = {
  home: '/',
  povsLk: '/lk/povs',
  povsEditElId: '/lk/povs/expertises/edit/:id',
  povsEditEl: '/lk/povs/expertises/edit/',
  povsLkDocuments: '/lk/povs/expertises',
  editApplication: '/lk/federal/application/edit/',
  editApplicationId: '/lk/federal/application/edit/:id',
  povsLkExpertise: '/lk/povs/expertise/',
  createNmsMeeting: '/lk/federal/nms/meeting/create',
  nmsInfoMeetingId: '/lk/nms/meeting/:id',
  editNmsMeetingId: '/lk/nms/meeting/edit/:id',
  editNmsMeeting: '/lk/nms/meeting/edit/',
  nmsFedInfoMeetingId: '/lk/federal/meeting/:id',
  nmsFedInfoMeeting: 'lk/federal/meeting',
  registeredRepresentative: '/registered_representative',
  nmsInfoMeeting: 'lk/nms/meeting',
  povsLkExpertiseId: '/lk/povs/expertise/:id',
  editPovsId: '/lk/federal/povs/:id',
  editPovs: '/lk/federal/povs',
  lkPovs: '/lk/federal/povs',
  createNmsMember: '/lk/federal/nms/members/create',
  createPovsMember: '/lk/federal/povs/create',
  registerRepresentativeConfirm: '/register_representative/confirm',
  register_representative: '/register_representative/',
  listOfOrganisations: '/list_of_organisations',
  lk: '/lk/federal/application',
  nmsProfile: '/lk/nms',
  nmsProfileMeeting: '/lk/nms/meeting',
  mainpage: '/',
  nmsMembers: '/lk/federal/nms/members',
  nmsMeeting: '/lk/federal/nms/meeting',
  nmsMeetingId: '/lk/federal/nms/meeting/:id',
  document: '/document/',
  documentId: '/document/:id',
  editTextbookId: '/lk/federal/edit/textbooks/:id',
  editTextbook: '/lk/federal/edit/textbooks',
  application: '/lk/federal/application',
  expert: '/lk/federal/expert',
  expertProfileId: '/lk/federal/expert/profile/:id',
  expertProfile: '/lk/federal/expert/profile',
  newExpert: '/lk/federal/expert/new',
  expertise: '/lk/federal/expertise',
  textbooks: '/lk/federal/textbooks',
  publisher: '/lk/federal/publisher',
  newPublisher: '/lk/federal/publisher/new',
  editPublisherId: '/lk/federal/publisher/edit/:id',
  editPublisher: '/lk/federal/publisher/edit/',
  representative: '/lk/federal/representative',
  document_category: '/lk/federal/document_category',
  newApplication: '/lk/federal/application/new',
  newDocumentCategory: '/lk/federal/document_category/new',
  showApplicationId: '/lk/federal/application/show/:id',
  showApplication: '/lk/federal/application/show/',
  textbookId: '/lk/federal/textbooks/show/:id',
  textbook: '/lk/federal/textbooks/show/',
  editDocumentCategoryId: '/lk/federal/document_category/edit/:id',
  editDocumentCategory: '/lk/federal/document_category/edit/',
  newDocumentId: '/lk/federal/document_category/document/new/:id',
  newDocument: '/lk/federal/document_category/document/new',
  editDocument: '/lk/federal/document_category/document/edit/',
  editDocumentId: '/lk/federal/document_category/document/edit/:id',
  representativeProfile: '/lk/representative/profile',
  representativeApplication: '/lk/representative/application',
  newRepresentativeApplication: '/lk/representative/application/new',
  editRepresentativeApplication: '/lk/representative/application/edit/',
  editRepresentativeApplicationId: '/lk/representative/application/edit/:id',
  expertExpertise: '/lk/expert/expertise/',
  expertExpertiseId: '/lk/expert/expertise/:id',
  editExpertExpertiseId: '/lk/expert/expertise/edit/:id',
  editExpertExpertise: '/lk/expert/expertise/edit/',
  expertOptionChouise: '/lk/expert/expertises',
  expertUserProfile: '/lk/expert/profile',
  nmsMemberId: '/lk/federal/nms/members/member/:id',
  nmsMember: '/lk/federal/nms/members/member/',
};

export const nonAuthRoutes: string[] = ['/', '/login'];
